/* @flow */
import navigation from 'services/NavigationService';
import { apiService } from 'services/ServiceRegistry';
import { activities } from 'components/Activity/ActivityData.js';

import Form from '../_.extend';

export const makeFields: Function = (costCenterData: Object, t: Function) => {
  let projectsStr: string = '';

  if (costCenterData && costCenterData.projects && costCenterData.projects.length > 0) {
    for (let i: * = 0; i < costCenterData.projects.length; i++) {
      projectsStr !== '' && (projectsStr += ',');
      projectsStr += costCenterData.projects[i].id;
    }
  }

  return [
    {
      // CHOOSE ACCOUNT
      name: 'chooseAccount',
      label:
        costCenterData && costCenterData.trading_account
          ? t('general:trading_account')
          : t('general:actions.choose_account'),
      fields: [
        {
          name: 'tradingAccount',
          label: t('general:actions.choose_trading_account'),
          rules: 'required|string',
          value:
            costCenterData && costCenterData.trading_account
              ? costCenterData.trading_account.name
              : null,
          extra: {
            selectID:
              costCenterData && costCenterData.trading_account
                ? costCenterData.trading_account.id
                : null,
          },
        },
      ],
    },
    {
      // COST CENTER DETAIL
      name: 'costCenterDetails',
      label: t('general:cost_centers.labels.details'),
      fields: [
        {
          name: 'costCenterCode',
          label: t('general:cost_centers.labels.code'),
          rules: 'required|string',
          value: costCenterData ? costCenterData.code : null,
        },
        {
          name: 'costCenterName',
          label: t('general:cost_centers.labels.name'),
          rules: 'required|string',
          value: costCenterData ? costCenterData.name : null,
        },
        {
          name: 'costCenterDescription',
          label: t('general:cost_centers.labels.description'),
          rules: 'string',
          multiline: true,
          value: costCenterData ? costCenterData.description : null,
        },
        {
          name: 'chooseStatus',
          label: t('general:cost_centers.labels.status'),
          rules: 'required|string',
          value: costCenterData.id ? (costCenterData.status ? 'Active' : 'Disabled') : '',
          options: [
            {
              id: 'Active',
              name: 'Active',
            },
            {
              id: 'Disabled',
              name: 'Disabled',
            },
          ],
        },
      ],
    },
    {
      // ASSIGN PROJECTS
      name: 'assignProjects',
      label: t('general:actions.assign_project_plural'),
      fields: [
        {
          name: 'projectAssign',
          label: t('general:actions.choose_projects'),
          rules: 'string',
          value: projectsStr,
          extra: {
            selectID: null,
            parentId:
              costCenterData && costCenterData.trading_account
                ? costCenterData.trading_account.id
                : null,
            actionButton: true,
          },
        },
      ],
    },
    {
      // ADITIONAL INFORMATION
      name: 'additionalInformation',
      label: t('general:additional_info'),
      fields: [
        {
          name: 'comments',
          label: t('general:labels.comments'),
          rules: 'string',
          multiline: true,
          value: costCenterData ? costCenterData.additional_info : null,
        },
      ],
    },
  ];
};

class CostCenterFormCreate extends Form {}

class CostCenterFormEdit extends Form {}

export const costCenterCreate: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const {
        costCenterCode,
        costCenterName,
        costCenterDescription,
        chooseStatus,
      }: Object = form.values().costCenterDetails;

      const { projectAssign }: Object = form.values().assignProjects;

      const { comments }: Object = form.values().additionalInformation;

      const arrProjectAssign = projectAssign ? projectAssign.split(',') : [];

      const jsonObj: Object = {
        activity_tag: activities.createdCostCenter.tag, // eslint-disable-line camelcase
        account_id: form.$('chooseAccount.tradingAccount').extra.selectID,
        code: costCenterCode,
        name: costCenterName,
        description: costCenterDescription,
        // 'status': chooseStatus,
        projects: arrProjectAssign,
        additional_info: comments,
        is_enabled: chooseStatus === 'Active',
      };

      !costCenterDescription && delete jsonObj.description;

      apiService
        .createResource('cost-centres', jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new CostCenterFormCreate(
    { fields },
    { hooks, name: t('general:actions.create_new_cost_center') }
  );
};

export const costCenterEdit: Function = (
  fields: Array<*>,
  costCenterData: Object,
  localState: Object,
  t: Function
) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const {
        costCenterCode,
        costCenterName,
        costCenterDescription,
        chooseStatus,
      }: Object = form.values().costCenterDetails;

      const { projectAssign }: Object = form.values().assignProjects;

      const { comments }: Object = form.values().additionalInformation;

      const arrProjectAssign = projectAssign ? projectAssign.split(',') : [];

      const jsonObj: Object = {
        activity_tag: activities.edited.tag, // eslint-disable-line camelcase
        account_id: form.$('chooseAccount.tradingAccount').extra.selectID,
        code: costCenterCode,
        name: costCenterName,
        description: costCenterDescription,
        // 'status': chooseStatus,
        projects: arrProjectAssign,
        additional_info: comments,
        is_enabled: chooseStatus === 'Active',
      };

      apiService
        .putResource(`cost-centres/${costCenterData.id}`, jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new CostCenterFormEdit({ fields }, { hooks, name: t('general:actions.edit_cost_center') });
};
